// Mock data for Le Tassili restaurant

export const restaurantInfo = {
  name: "Le Tassili",
  tagline: "Pizzas artisanales, Sandwichs, Tacos – Saveurs authentiques.",
  location: "Les Ulis",
  address: "2 Avenue de Bourgognes, 91940 Les Ulis (Centre Commercial Les Boutiques Parisiennes)",
  phone: "+33 1 60 92 56 50",
  phoneSecondary: "+33 6 26 63 54 05",
  phoneDisplay: "01 60 92 56 50",
  phoneLink: "tel:+33160925650",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2631.8!2d2.167!3d48.682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDQwJzU1LjIiTiAywrAxMCcwMC42IkU!5e0!3m2!1sfr!2sfr!4v1234567890",
  payments: ["Espèces", "CB", "Tickets resto"],
  badges: ["Halal"],
  openingHours: {
    lundi: "11:45–14:20, 18:00–22:20",
    mardi: "11:45–14:20, 18:00–22:20",
    mercredi: "11:45–14:20, 18:00–22:20",
    jeudi: "11:45–14:20, 18:00–22:20",
    vendredi: "11:45–14:20, 18:00–22:20",
    samedi: "11:45–14:20, 18:00–22:20",
    dimanche: "18:00–22:20"
  }
};

export const aboutText = {
  title: "À propos du Tassili",
  cards: [
    {
      title: "Ingrédients frais",
      description: "Nos recettes sont préparées chaque jour avec des ingrédients frais, sélectionnés avec soin pour garantir goût et qualité.",
      icon: "chef"
    },
    {
      title: "Viandes halal",
      description: "Toutes nos viandes sont halal, pour vous offrir une expérience en toute confiance et en toute sérénité.",
      icon: "halal"
    },
    {
      title: "Livraison 7j/7",
      description: "Profitez de nos délicieux plats chez vous avec notre service de livraison disponible tous les jours de la semaine.",
      icon: "delivery"
    }
  ]
};

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxwaXp6YXxlbnwwfHx8fDE3NzU0ODU5Nzl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Pizza Le Tassili",
    category: "Pizza"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/1566837/pexels-photo-1566837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Pizzas artisanales",
    category: "Pizza"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1498579150354-977475b7ea0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwZm9vZHxlbnwwfHx8fDE3NzU0ODU5NzR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Pâtes fraîches",
    category: "Pasta"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1556761223-4c4282c73f77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwZm9vZHxlbnwwfHx8fDE3NzU0ODU5NzR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Spaghetti Le Tassili",
    category: "Pasta"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1506280754576-f6fa8a873550?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxpdGFsaWFuJTIwZm9vZHxlbnwwfHx8fDE3NzU0ODU5NzR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Bruschetta",
    category: "Entrées"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1616299915952-04c803388e5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwZm9vZHxlbnwwfHx8fDE3NzU0ODU5NzR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Plat italien",
    category: "Plats"
  }
];

export const menuData = {
  pizzas: {
    title: "Les Pizzas",
    offers: {
      title: "🎉 PROMOTIONS",
      sections: [
        {
          type: "À EMPORTER (7/7)",
          emoji: "🛍️",
          offer: "1 PIZZA ACHETÉE = LA 2ème OFFERTE",
          conditions: [
            "*valable sur sénior et méga sauf marguerita.",
            "la pizza la moins chère sera offerte.",
            "Offre non cumulable, à signaler à la commande"
          ]
        },
        {
          type: "EN LIVRAISON (7/7)",
          emoji: "🚗",
          offer: "2 PIZZAS ACHETÉES = LA 3ème OFFERTE",
          conditions: [
            "*valable sur sénior et méga sauf marguerita.",
            "la pizza la moins chère sera offerte.",
            "Offre non cumulable, à signaler à la commande"
          ]
        }
      ]
    },
    promos: [
      {
        name: "Promo 1",
        description: "3 Pizzas Junior au choix + 1 Maxi Coca 1,25L",
        price: "23,00€"
      },
      {
        name: "Promo 2",
        description: "3 Pizzas Senior au choix + 1 Maxi Coca 1,25L",
        price: "32,00€"
      },
      {
        name: "Promo 3",
        description: "2 Pizzas Senior au choix + 1 Maxi Coca 1,25L",
        price: "24,00€"
      },
      {
        name: "Promo 4",
        description: "2 Pizzas Mega au choix + 1 Maxi Coca 1,25L",
        price: "42,00€"
      }
    ],
    categories: [
      {
        subtitle: "🍕 Base Tomate",
        items: [
          { name: "Margherita", description: "Tomate, fromage", prices: { junior: "7,00€", senior: "13,00€", mega: "18,00€" } },
          { name: "Reine", description: "Tomate, fromage, jambon, champignons", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Sicilienne", description: "Tomate, fromage, anchois, câpres, olives", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Orientale", description: "Tomate, fromage, merguez, poivrons, œuf", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Juliette", description: "Tomate, fromage, viande hachée, champignons, oignons", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "4 Saisons", description: "Tomate, fromage, jambon, champignons, artichauts", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Végétarienne", description: "Tomate, fromage, champignons, artichauts, tomates fraîches, oignons, basilic", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "4 Fromages", description: "Tomate, fromage, chèvre, brie, parmesan", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Royale", description: "Tomate, fromage, jambon, chorizo, lardons", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Etna", description: "Tomate, fromage, jambon, merguez, champignons, origan, œuf", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Toscana", description: "Tomate, fromage, thon, tomates fraîches, olives, œuf", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Tassili Tomate", description: "Tomate, fromage, viande grecque, oignons", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" }, featured: true },
          { name: "Charcutière", description: "Tomate, fromage, jambon, chorizo, merguez", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Fajitas", description: "Tomate, fromage, poulet, poivrons", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Podium", description: "Tomate, fromage, poulet, merguez, viande hachée", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Boursin", description: "Tomate, fromage, viande hachée, boursin, pommes de terre", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Carnivore", description: "Tomate, fromage, poulet, merguez, boulettes de viande", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Mexicaine", description: "Tomate, fromage, thon, merguez, poivrons, œuf", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "La Spezia Tomate", description: "Tomate, fromage, poulet, pommes de terre, chèvre", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Américaine", description: "Tomate, fromage, merguez, jambon, chorizo, champignons, œuf", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Thonara", description: "Tomate, fromage, thon, poivrons, oignons, olives, œuf", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } },
          { name: "Class", description: "Tomate, fromage, viande hachée, jambon, chorizo, poivrons, oignons", prices: { junior: "8,00€", senior: "16,00€", mega: "22,00€" } }
        ]
      },
      {
        subtitle: "🍕 Pizzas à Sauce",
        items: [
          { name: "India", description: "Sauce curry, fromage, poulet, oignons, tomates fraîches", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Barbecue", description: "Sauce barbecue, fromage, viande hachée, poivrons, oignons", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Algérienne", description: "Sauce algérienne, fromage, viande hachée, poivrons, oignons, olives", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" }, featured: true },
          { name: "Samouraï", description: "Sauce samouraï, fromage, viande grecque, oignons, tomates fraîches", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } }
        ]
      },
      {
        subtitle: "🍕 Base Crème Fraîche",
        items: [
          { name: "2024", description: "Crème fraîche, fromage, lardons, chorizo, œuf", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Tartiflette", description: "Crème fraîche, fromage, lardons, pommes de terre, oignons", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Fromagère", description: "Crème fraîche, fromage, assortiment de 4 fromages", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Brésilienne", description: "Crème fraîche, fromage, viande hachée, merguez, œuf", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Chavignole", description: "Crème fraîche, fromage, chèvre, parmesan, olives", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Parmentière", description: "Crème fraîche, fromage, viande hachée, pommes de terre, reblochon", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Paysanne", description: "Crème fraîche, fromage, jambon, pommes de terre, parmesan, œuf, persil", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "La Spezia", description: "Crème fraîche, fromage, poulet, pommes de terre, chèvre", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Raclette", description: "Crème fraîche, fromage, jambon, raclette, pommes de terre", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Chèvre Miel", description: "Crème fraîche, fromage, chèvre, miel", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Tassili Crème", description: "Crème fraîche, fromage, viande grecque, oignons", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" }, featured: true },
          { name: "Fermière", description: "Crème fraîche, fromage, poulet, brie, pommes de terre", prices: { junior: "9,00€", senior: "16,50€", mega: "23,00€" } },
          { name: "Saumon", description: "Crème fraîche, fromage, saumon fumé, citron", prices: { junior: "11,00€", senior: "17,00€", mega: "24,00€" } }
        ]
      }
    ],
    supplement: "Ingrédient supplémentaire: +1,00€ (Junior) | +1,50€ (Senior) | +2,00€ (Mega)"
  },
  sandwiches: {
    title: "Les Sandwichs",
    subtitle: "Servis avec salade, tomates, oignons + frites",
    items: [
      { name: "Grec", description: "Viande grecque", price: "7,00€" },
      { name: "Chicken Tikka", description: "Escalope de poulet marinée au curry, cheddar", price: "7,00€" },
      { name: "Escalope", description: "Escalope de poulet grillée", price: "7,00€" },
      { name: "Merguez", description: "Merguez", price: "7,00€" },
      { name: "Américain", description: "Steak, œuf, cheddar", price: "7,00€" },
      { name: "Kefta", description: "Viande de veau farcie, cheddar", price: "7,50€" },
      { name: "Mexicain", description: "Filet de poulet, merguez, cheddar", price: "7,00€" },
      { name: "Cordon Bleu", description: "2 cordons bleus", price: "7,00€" },
      { name: "Spécial", description: "Merguez, chicken tikka, viande grecque, cheddar", price: "8,50€" },
      { name: "Cordon Steak", description: "Steak, cordon bleu, cheddar", price: "8,50€" },
      { name: "Phénomène", description: "Cordon bleu, poulet, cheddar", price: "8,50€" },
      { name: "Tortilla", description: "1 viande au choix", price: "7,00€" }
    ]
  },
  burgers: {
    title: "Les Burgers",
    items: [
      { name: "Cheese", description: "1 steak, cheddar", price: "6,00€" },
      { name: "Double Cheese", description: "2 steaks, cheddar", price: "7,00€" },
      { name: "Triple Cheese", description: "3 steaks, cheddar", price: "8,00€" },
      { name: "Cheese Bacon", description: "1 steak, bacon, cheddar", price: "7,00€" },
      { name: "Double Bacon", description: "2 steaks, bacon, cheddar", price: "8,50€" },
      { name: "Chicken Burger", description: "Poulet pané, cheddar", price: "7,00€" },
      { name: "Big Burger", description: "Steak 180g, cheddar", price: "8,50€" },
      { name: "Double Big Burger", description: "2 steaks 180g", price: "12,00€" }
    ]
  },
  tacos: {
    title: "French Tacos",
    note: "Sauce fromagère + frites à l'intérieur",
    items: [
      { name: "Simple", description: "1 viande au choix", price: "7,50€" },
      { name: "Double", description: "2 viandes au choix", price: "8,50€" },
      { name: "Triple", description: "3 viandes au choix", price: "9,50€" }
    ],
    viandes: "Viandes au choix: escalope, merguez, viande hachée, tenders, cordon bleu, nuggets, kebab, kefta"
  },
  assiettes: {
    title: "Les Assiettes",
    subtitle: "12,50€ - Servies avec salade, tomates, oignons, frites",
    items: [
      { name: "Grecque", description: "Viande grecque", price: "12,50€" },
      { name: "Américaine", description: "Steak haché", price: "12,50€" },
      { name: "Chicken Tikka", description: "Filet de poulet mariné", price: "12,50€" },
      { name: "Cordon Bleu", description: "Cordon bleu", price: "12,50€" },
      { name: "Kefta", description: "Viande de bœuf, fromage, œuf", price: "12,50€" },
      { name: "Mexicaine", description: "Poulet, merguez, poivrons", price: "12,50€" },
      { name: "Poulet", description: "Cuisse de poulet", price: "12,50€" },
      { name: "Escalope", description: "Escalope de poulet marinée, toastinette", price: "12,50€" }
    ]
  },
  braises: {
    title: "Les Rôtis",
    items: [
      { name: "Poulet rôti entier", description: "Avec frites", price: "15,00€" },
      { name: "Cuisse de poulet", description: "Avec frites", price: "6,50€" },
      { name: "Barquette de riz", description: "Riz seul", price: "3,00€" }
    ]
  },
  salades: {
    title: "Les Salades",
    price: "7,00€",
    items: [
      { name: "Niçoise", description: "Salade, tomates, thon, olives, vinaigrette à l'huile d'olive", price: "7,00€" },
      { name: "Hippone", description: "Salade, tomates, filet de poulet grillé, cheddar, sauce salade", price: "7,00€" },
      { name: "Chèvre chaud", description: "Toast de chèvre chaud sur lit de salade", price: "7,00€" },
      { name: "Chef", description: "Salade, tomates, jambon, emmental", price: "7,00€" },
      { name: "Ulisienne", description: "Salade, tomates, jambon, mozzarella, olives, vinaigrette à l'huile d'olive", price: "7,00€" }
    ]
  },
  paninis: {
    title: "Les Paninis",
    price: "7,00€",
    note: "+ frites + boisson 33cl",
    items: [
      { name: "Thon", description: "Tomates, gruyère, thon" },
      { name: "Best", description: "Tomates, gruyère, champignons, viande hachée" },
      { name: "Parisien", description: "Tomates, gruyère, jambon" },
      { name: "Royal", description: "Tomates, jambon, reblochon" },
      { name: "Saumon", description: "Crème fraîche, saumon fumé, ciboulette" },
      { name: "Cocktail", description: "Tomates, gruyère, chèvre, brie, mozzarella" },
      { name: "Merguez", description: "Tomates, gruyère, merguez" },
      { name: "Poulet", description: "Tomates, gruyère, poulet" }
    ]
  },
  texmex: {
    title: "Les Tex Mex",
    categories: [
      {
        name: "Chicken Wings",
        items: [
          { quantity: "6 pièces", price: "5,50€" },
          { quantity: "8 pièces", price: "7,50€" },
          { quantity: "12 pièces", price: "9,50€" }
        ]
      },
      {
        name: "Nuggets",
        items: [
          { quantity: "6 pièces", price: "5,50€" },
          { quantity: "8 pièces", price: "7,50€" },
          { quantity: "12 pièces", price: "9,50€" }
        ]
      },
      {
        name: "Tenders",
        items: [
          { quantity: "6 pièces", price: "6,00€" },
          { quantity: "8 pièces", price: "8,00€" },
          { quantity: "12 pièces", price: "11,00€" }
        ]
      },
      {
        name: "Frites",
        items: [
          { quantity: "Petite", price: "2,00€" },
          { quantity: "Grande", price: "3,50€" }
        ]
      }
    ]
  },
  boissons: {
    title: "Les Boissons",
    items: [
      { name: "Canette 33cl", price: "1,50€" },
      { name: "Coca 1,5L", price: "2,00€" },
      { name: "Maxi Coca 1,5L", price: "3,00€" },
      { name: "Maxi Oasis 2L", price: "3,50€" }
    ]
  },
  desserts: {
    title: "Les Desserts",
    items: [
      { name: "Tiramisu", price: "3,50€" },
      { name: "Brownie", price: "2,50€" },
      { name: "Tarte au Daim", price: "3,00€" }
    ]
  },
  glaces: {
    title: "Les Glaces",
    subtitle: "Häagen-Dazs",
    items: [
      { name: "Häagen-Dazs 100ml", price: "4,50€" },
      { name: "Häagen-Dazs 500ml", price: "8,00€" }
    ]
  },
  menus: {
    title: "Menus",
    items: [
      {
        name: "Menu Bambino",
        description: "1 Cheese + Frites OU 5 Nuggets + Frites + Capri-Sonne",
        price: "6,00€"
      }
    ]
  }
};
